"use strict";

var superagent = require("superagent");

function GoogleCalendarAPI(apiURL, sessionId) {
  this.apiURL = apiURL;
  this.sessionId = sessionId || getDefaultSessionId();

  function getDefaultSessionId() {
    return (typeof window !== "undefined" && window.getCookie)?window.getCookie("PHPSESSID"):null;
  }
}

GoogleCalendarAPI.request = function request(options) {
  superagent.get(options.endpoint)
    .query("fields=items(id%2Csummary)")
    .set("Accept", "application/json")
    .set("Authorization", options.credential.type + " " + options.credential.authKey)
    .end(options.onCompleted);
};

module.exports = GoogleCalendarAPI;



// WEBPACK FOOTER //
// ./app/util/api/google-calendar-api.js